import cashIcon from "assets/images/money.svg";
import { EmptySection } from "../../shared/EmptySection";

export const EmptyCashFlowSection = () => {
  // action

  return <EmptySection img={cashIcon} title="Na bieżąco śledź transakcje" />;
};
